exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cardPersonalizada card-header{background-color:#4db35a;color:#fff}.conta{padding:3%}.borderF{border:1px solid #dcdcdc;margin:1%}.borderC{border:1px solid gray;margin:1%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5148557b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/componentes/detalles.vue
// module id = 441
// module chunks = 0